<div *ngIf="loading">Please wait while your request is being created.</div>
<!-- <div *ngIf="!loading">loading false.</div> -->